import { render, staticRenderFns } from "./AdSettings.vue?vue&type=template&id=31911712&scoped=true"
import script from "./AdSettings.vue?vue&type=script&lang=js"
export * from "./AdSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31911712",
  null
  
)

export default component.exports